import React from 'react';
import { PRIMARY_500 } from '@amzn/ring-common-style-library/lib/colors';
import { translated } from '../../utils/TranslationUtil';

export const RadioIcon: React.FC<{}> = () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height='100%' width='100%' fill='none'>
        <title>{translated('Accessibility.SvgTitle.radioIcon')}</title>
        <path
            d='M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z'
            fill={PRIMARY_500}
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M0 12C0 5.37 5.37 0 12 0C18.63 0 24 5.37 24 12C24 18.63 18.63 24 12 24C5.37 24 0 18.63 0 12ZM22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12Z'
            fill={PRIMARY_500}
        />
    </svg>
);
